import script from "./SettlementRates.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementRates.vue?vue&type=script&setup=true&lang=js"

import "./SettlementRates.vue?vue&type=style&index=0&id=8d8d1474&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8d1474"]])

export default __exports__